// Vendor Libraries
import React, {useEffect, useState} from 'react';
import * as PropTypes from 'prop-types';

// Primereact
import {TreeTable} from 'primereact/treetable';
import {Column} from 'primereact/column';
import {Checkbox} from 'primereact/checkbox';

const styles = {
    columnLaunchId: {width: 120},
    columnId: {width: 120},
    lid_warning: {color: '#07619c', fontWeight: 600, display: 'flex'},
    infoIcon: {fontSize: '2rem', color: 'orange'},
    infoText: {marginTop: 5},
    infoText2: {marginTop: 5},
    toggleButton: {marginLeft: 10, marginTop: 6, display: 'flex'},
    toggleLabel: {marginTop: -3},
};

const selectorFieldName = 'launchId';

const traverseData = data => {
    const targetFields = ['id', 'launchId', 'name'];
    const childrenFieldName = 'subShelves';
    const childrenParentName = 'ShelfDTO';
    const newParentObj = [];

    const getRequiredFields = obj => {
        const tempObj = {};
        for (const [key, value] of Object.entries(obj)) {
            if (targetFields.includes(key)) {
                tempObj[key] = value;
            }
        }
        return {data: tempObj};
    };

    const iterateObj = obj => {
        for (const [key, value] of Object.entries(obj)) {
            const parent = getRequiredFields(obj);
            parent.children = [];
            if (key === childrenFieldName) {
                value.forEach(v => {
                    const children = getRequiredFields(v[childrenParentName]);
                    children.parentId = parent.data.id;
                    children.data.name = `${children.data.name} (${parent.data.name})`;
                    parent.children.push(children);
                    newParentObj.push(parent);
                    iterateObj(v[childrenParentName]);
                });
            }
        }
    };

    iterateObj(data[childrenParentName]);

    const newParentObjUnique = [...new Set(newParentObj)];
    let pIterator = 0;
    newParentObjUnique.forEach(o => {
        o.key = pIterator.toString();
        let iterator = 0;
        o.children.forEach(ch => {
            ch.key = `${pIterator}-${iterator}`;
            iterator += 1;
        });
        pIterator += 1;
    });

    return newParentObjUnique;
};

const LaunchIdTreeTable = ({setSelectedLaunchId, data}) => {
    const nodes = traverseData(data);
    const [selectedNodeKey, setSelectedNodeKey] = useState();
    const [expandedKeys, setExpandedKeys] = useState({});
    const [checked, setChecked] = useState(false);

    const toggleShelves = () => {
        const expandedKeysTemp = {...expandedKeys};
        nodes.forEach((_, index) => {
            if (expandedKeysTemp[index.toString()]) {
                delete expandedKeysTemp[index.toString()];
            } else {
                expandedKeysTemp[index.toString()] = true;
            }
        });
        setChecked(!checked);
        setExpandedKeys(expandedKeysTemp);
    };

    useEffect(() => {
        if (selectedNodeKey) {
            if (selectedNodeKey.indexOf('-') <= -1) {
                setSelectedLaunchId(nodes.find(d => d.key === selectedNodeKey).data[selectorFieldName]);
            } else {
                const parts = selectedNodeKey.split('-');
                setSelectedLaunchId(
                    nodes[parts[0]].children.find(d => d.key === selectedNodeKey).data[selectorFieldName]
                );
            }
        }
    }, [selectedNodeKey]);

    const column = (style, field, header, isExpander = false, sortable = true, filter = true) => (
        <Column
            expander={isExpander}
            field={field}
            filter={filter}
            filterMatchMode="contains"
            header={header}
            sortable={sortable}
            style={style}
        />
    );

    const arrowButton = () => <i className="pi pi-angle-right" style={{fontSize: '2rem'}} />;

    return (
        <div className="launchIdTree">
            <div style={{display: 'flex'}}>
                <div style={styles.lid_warning}>
                    <i className="pi pi-info-circle" style={styles.infoIcon} />
                    <span style={styles.infoText}>Use the button</span>
                    <span>{arrowButton()}</span>
                    <span style={styles.infoText2}>to access nested shelves.</span>
                </div>
                <span style={styles.toggleButton}>
                    <Checkbox checked={checked} onChange={toggleShelves} />
                    <label className="p-checkbox-label" style={styles.toggleLabel}>
                        {`${checked ? 'Collapse' : 'Expand'} All Shelves`}
                    </label>
                </span>
            </div>
            <TreeTable
                defaultSortOrder={-1}
                expandedKeys={expandedKeys}
                paginator={true}
                rows={5}
                scrollHeight="300px"
                scrollable={true}
                selectionKeys={selectedNodeKey}
                selectionMode="single"
                value={nodes}
                onSelectionChange={e => setSelectedNodeKey(e.value)}
                onToggle={e => setExpandedKeys(e.value)}
            >
                {column({}, 'name', 'Name', true)}
                {column(styles.columnId, 'id', 'ID', false)}
                {column(styles.columnLaunchId, 'launchId', 'Launch ID', false)}
            </TreeTable>
        </div>
    );
};

LaunchIdTreeTable.propTypes = {
    data: PropTypes.object,
    setSelectedLaunchId: PropTypes.func,
};

export default LaunchIdTreeTable;
